import type { Action } from '@atlassian/react-sweet-state';
import type { ContainerProps, State } from '../types.tsx';
import type { RuleConfig, RuleSummary } from '../../common/types.tsx';
import { fetchRuleConfig } from '../../services/fetch-rule.tsx';

export const bootstrap =
	(): Action<State, ContainerProps> =>
	async ({ setState }, { issueKey }) => {
		setState({
			isLoading: true,
			errors: null,
		});

		try {
			const { value } = await fetchRuleConfig(issueKey);

			setState({
				isLoading: false,
				hasFetched: true,
				issueProperties: value,
			});
		} catch (error: unknown) {
			setState({
				isLoading: false,
				hasFetched: true,
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				errors: [error as Error],
			});
		}
	};

export const setRuleSummary =
	(ruleSummary: RuleSummary): Action<State, ContainerProps> =>
	({ getState, setState }) => {
		setState({
			...getState(),
			ruleSummary,
		});
	};

export const setIssueProperties =
	(issueProperties: RuleConfig): Action<State, ContainerProps> =>
	({ getState, setState }) => {
		setState({
			...getState(),
			issueProperties,
		});
	};

export type Actions = {
	setRuleSummary: typeof setRuleSummary;
	setIssueProperties: typeof setIssueProperties;
};

export const actions = {
	bootstrap,
	setRuleSummary,
	setIssueProperties,
};
